// extracted by mini-css-extract-plugin
export var divider = "_fk-7";
export var itemsToggle = "_fk-8";
export var mergeModal = "_fk-1";
export var optionCard = "_fk-4";
export var radioGroup = "_fk-6";
export var radioOption = "_fk-0";
export var selected = "_fk-5";
export var shipmentOptions = "_fk-2";
export var tableOptions = "_fk-3";